import { convertFromRaw, EditorState } from 'draft-js'
import createBasicJroTemplate from './basic-jro'
import createColorBlockTemplate from './color-block'

const TEMPLATES = {
  basicJro: createBasicJroTemplate,
  colorblock: createColorBlockTemplate,
}

export const convertTemplateToEditorState = templateName => {
  const rawStateCreatorFn = TEMPLATES[templateName]
  const rawState = rawStateCreatorFn()
  const contentState = convertFromRaw(rawState)
  return EditorState.createWithContent(contentState)
}

export const TEMPLATE_NAMES = Object.keys(TEMPLATES)

export default TEMPLATES



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/message-templates/index.js